<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<label class="container">
  @if (type() === 'radio') {
    <input
      type="radio"
      [attr.name]="name()"
      [value]="value()"
      [formControl]="controller()"
      [id]="id()" />
  } @else {
    <input
      type="checkbox"
      [attr.name]="name()"
      [value]="value()"
      [formControl]="controller()"
      [id]="id()" />
  }
  <span class="checkmark">
    <orbit-fa-icon [iconName]="checkmark" />
  </span>
</label>
@if (label() && id()) {
  <label class="label" [for]="id()">{{ label() }}</label>
}
